import copy from "fast-copy";

export default <T>( object: T ): T => copy( object ) as T;
